import {
  Box,
  Card,
  CardMedia,
  CardActions,
  Typography,
  styled,
} from '@mui/material';

export const StyledCard = styled(Card)(({ theme }) => ({
  gridColumn: 'span 3',
  [theme.breakpoints.down('desktop')]: {
    gridColumn: 'span 4',
  },
  [theme.breakpoints.down('md')]: {
    gridColumn: 'span 6',
  },
  [theme.breakpoints.down('sm')]: {
    gridColumn: 'span 12',
  },
}));

export const StyledCardMedia = styled(CardMedia)(({ theme }) => ({
  aspectRatio: '1',
  display: 'flex',
  [theme.breakpoints.down('md')]: {
    justifyContent: 'center',
  },
}));

export const StyledCardMediaInner = styled(Box)(() => ({
  position: 'relative',
}));

export const StyledCoverArt = styled('img')({
  width: '100%',
  height: '100%',
});

export const StyledPlayerWrapper = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  left: 0,
  padding: 0,
  margin: theme.spacing(3, 2),
  borderRadius: theme.spacing(5),
  background: theme.palette.grey[700],
}));

export const StyledCardActions = styled(CardActions)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2),
}));

export const StyledTitle = styled(Typography)(() => ({
  fontSize: 16,
  fontWeight: 600,
}));

export const StyledArtistName = styled(Typography)(() => ({
  fontSize: 12,
}));

export const StyledSubtitle = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.grey[400],
}));

export const StyledActionIcon = styled(Box)(() => ({
  fontSize: 'medium',
  cursor: 'pointer',
}));
